import { FormChildQuestionDto, FormQuestionDto } from "@green0meter/api-client";
import React, { FC, memo } from "react";
import { Controller } from "react-hook-form";
import { Slider as MuiSlider } from "@mui/material";

import { Box, Stack, TextField } from "@components/base";

interface Slider {
  question: FormQuestionDto | FormChildQuestionDto;
  disabled?: boolean;
}

const Slider: FC<Slider> = ({ question, disabled }) => {
  return (
    <Controller
      name={question.code}
      render={({ field }) => (
        <Stack spacing={3} direction="row" alignItems="center" pl={1}>
          <MuiSlider {...field} disabled={disabled} step={1} min={0} max={100} />
          <Box width={128}>
            <TextField
              {...field}
              variant="filled"
              size="small"
              disabled={disabled}
              slotProps={{
                input: {
                  type: "number",
                  endAdornment: "%",
                },
              }}
            />
          </Box>
        </Stack>
      )}
    />
  );
};

export default memo(Slider);
